import { all } from "redux-saga/effects";
import authSaga from "../pages/sing-in/slice/saga";

export default function* rootSaga() {
  yield all([authSaga()]);
}
